<template>
  <div v-if="$site?.location" class="overflow-x-hidden">
    <component :is="structure">
      <NuxtPage/>
    </component>

    <UNotifications />

    <div id="teleports" class="bottom-16 fixed w-full z-20" />
  </div>
</template>

<script setup lang="ts">
import {
  LayoutWeb,
  LayoutWidget,
  LayoutBot,
  LayoutBookApp
} from '#components'

const { $site } = useNuxtApp()

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk;
  }
})

defineOgImageComponent('Preview')

useSiteHead()

const layoutStore = useLayoutStore()

const structure = computed(() => {
  switch(layoutStore.layout) {
    case 'bot':
      return LayoutBot
    case 'facebook':
      return LayoutWidget
    case 'widget':
      return LayoutWidget
    case 'app':
      return LayoutBookApp
    default:
      return LayoutWeb
  }
})
</script>